import { render, staticRenderFns } from "./OrderSelectAddress.vue?vue&type=template&id=e9c16af8&scoped=true&"
import script from "./OrderSelectAddress.vue?vue&type=script&lang=js&"
export * from "./OrderSelectAddress.vue?vue&type=script&lang=js&"
import style0 from "./OrderSelectAddress.vue?vue&type=style&index=0&id=e9c16af8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c16af8",
  null
  
)

export default component.exports